/**
 * @generated SignedSource<<a21dc2f8c4b1ff1593aa5b96411bbcf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MarkProgramAsFavoriteInput = {
  programId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type markProgramAsFavoriteMutation$variables = {
  input: MarkProgramAsFavoriteInput;
};
export type markProgramAsFavoriteMutation$data = {
  readonly markProgramAsFavorite: {
    readonly program: {
      readonly node: {
        readonly id: string;
        readonly userRelationTypes: ReadonlyArray<string | null> | null;
      } | null;
    } | null;
  } | null;
};
export type markProgramAsFavoriteMutation = {
  variables: markProgramAsFavoriteMutation$variables;
  response: markProgramAsFavoriteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkProgramAsFavoritePayload",
    "kind": "LinkedField",
    "name": "markProgramAsFavorite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectServiceProgramTypeEdge",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgramType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userRelationTypes",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "markProgramAsFavoriteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "markProgramAsFavoriteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "251c1dac9f77ebae660df205cc0eba48",
    "id": null,
    "metadata": {},
    "name": "markProgramAsFavoriteMutation",
    "operationKind": "mutation",
    "text": "mutation markProgramAsFavoriteMutation(\n  $input: MarkProgramAsFavoriteInput!\n) {\n  markProgramAsFavorite(input: $input) {\n    program {\n      node {\n        id\n        userRelationTypes\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "10f9ad2de089c97486682d24001f3dff";

export default node;
